let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("e71zw")).then(() => parcelRequire('gc2UW'));